import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { getBuildIdQuery, IFilterPageLayout, ILink } from '@ncg/data';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { Subject, takeUntil } from 'rxjs';
import { take } from 'rxjs/operators';

import { ProductsFacade } from '../../+state/products/products.facade';
import { SettingsService } from '../../core/settings.service';
import { SidePanelService } from '../../side-panel/side-panel.service';

@Component({
    selector: 'ncg-my-profile-button',
    template: `<a
        *ngIf="enabled && (seezSidePanelLink?.url || seezMyProfileLink?.url)"
        [href]="seezMyProfileLink?.url"
        [attr.target]="seezMyProfileLink?.target"
        class="button is-primary is-rounded is-product-sorting product-sorting__btn-my-profile"
        (click)="onMyProfileLinkClick($event)"
        [attr.aria-label]="seezSidePanelLink?.name || seezMyProfileLink?.name"
    >
        <span class="icon">
            <svg-icon-sprite
                [src]="'assets/images/sprite-multi.svg' + buildIdQuery + '#profile-user'"
                [viewBox]="'0 0 30 30'"
                [width]="'30px'"
                [height]="'30px'"
                aria-hidden="true"
            ></svg-icon-sprite>
        </span>
    </a>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyProfileButtonComponent implements OnInit, OnDestroy {
    buildIdQuery = getBuildIdQuery();
    filterPageLayout?: IFilterPageLayout;
    seezMyProfileLink?: ILink;
    seezSidePanelLink?: ILink;
    enabled: boolean = false;
    private readonly unsubscribe = new Subject<void>();

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly productsFacade: ProductsFacade,
        private readonly sidePanelService: SidePanelService,
        public readonly settingsService: SettingsService
    ) {}

    ngOnInit() {
        this.productsFacade.layout$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
            if (data) {
                this.filterPageLayout = data.pageLayout;
                this.cd.markForCheck();
            }
        });

        this.settingsService
            .get()
            .pipe(take(1), takeUntil(this.unsubscribe))
            .subscribe((settings) => {
                this.enabled = settings.seezSetup.enabled;
                this.seezMyProfileLink = settings.seezSetup.myProfileLink;
                this.seezSidePanelLink = settings.seezSetup.sidePanelLink;
                if (this.seezSidePanelLink && settings.seezSetup.sidePanelLinkText) {
                    this.seezSidePanelLink.name = settings.seezSetup.sidePanelLinkText;
                }
                this.cd.markForCheck();
            });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    onMyProfileLinkClick(e: MouseEvent) {
        if (this.seezSidePanelLink?.url) {
            e.preventDefault();
            this.sidePanelService.openContent(this.seezSidePanelLink.url, 'myprofile');
        }
    }
}

@NgModule({
    imports: [CommonModule, IconSpriteModule],
    declarations: [MyProfileButtonComponent],
    exports: [MyProfileButtonComponent],
})
export class MyProfileButtonModule {}
